// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Subscription parameters (server-side Subscription settings).
 */
export class SubscriptionConfig implements flatbuffers.IUnpackableObject<SubscriptionConfigT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SubscriptionConfig {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSubscriptionConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: SubscriptionConfig,
  ): SubscriptionConfig {
    return (obj || new SubscriptionConfig()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSubscriptionConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: SubscriptionConfig,
  ): SubscriptionConfig {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SubscriptionConfig()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  publishingIntervalMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 1000.0;
  }

  lifetimeCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 10;
  }

  maxKeepAliveCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 30;
  }

  maxNotificationsPerPublish(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  priority(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  samplingIntervalMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
  }

  queueSize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 1;
  }

  publishingEnabled(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  static startSubscriptionConfig(builder: flatbuffers.Builder) {
    builder.startObject(8);
  }

  static addPublishingIntervalMs(builder: flatbuffers.Builder, publishingIntervalMs: number) {
    builder.addFieldFloat64(0, publishingIntervalMs, 1000.0);
  }

  static addLifetimeCount(builder: flatbuffers.Builder, lifetimeCount: number) {
    builder.addFieldInt32(1, lifetimeCount, 10);
  }

  static addMaxKeepAliveCount(builder: flatbuffers.Builder, maxKeepAliveCount: number) {
    builder.addFieldInt32(2, maxKeepAliveCount, 30);
  }

  static addMaxNotificationsPerPublish(
    builder: flatbuffers.Builder,
    maxNotificationsPerPublish: number,
  ) {
    builder.addFieldInt32(3, maxNotificationsPerPublish, 0);
  }

  static addPriority(builder: flatbuffers.Builder, priority: number) {
    builder.addFieldInt8(4, priority, 0);
  }

  static addSamplingIntervalMs(builder: flatbuffers.Builder, samplingIntervalMs: number) {
    builder.addFieldFloat64(5, samplingIntervalMs, 0.0);
  }

  static addQueueSize(builder: flatbuffers.Builder, queueSize: number) {
    builder.addFieldInt32(6, queueSize, 1);
  }

  static addPublishingEnabled(builder: flatbuffers.Builder, publishingEnabled: boolean) {
    builder.addFieldInt8(7, +publishingEnabled, +true);
  }

  static endSubscriptionConfig(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createSubscriptionConfig(
    builder: flatbuffers.Builder,
    publishingIntervalMs: number,
    lifetimeCount: number,
    maxKeepAliveCount: number,
    maxNotificationsPerPublish: number,
    priority: number,
    samplingIntervalMs: number,
    queueSize: number,
    publishingEnabled: boolean,
  ): flatbuffers.Offset {
    SubscriptionConfig.startSubscriptionConfig(builder);
    SubscriptionConfig.addPublishingIntervalMs(builder, publishingIntervalMs);
    SubscriptionConfig.addLifetimeCount(builder, lifetimeCount);
    SubscriptionConfig.addMaxKeepAliveCount(builder, maxKeepAliveCount);
    SubscriptionConfig.addMaxNotificationsPerPublish(builder, maxNotificationsPerPublish);
    SubscriptionConfig.addPriority(builder, priority);
    SubscriptionConfig.addSamplingIntervalMs(builder, samplingIntervalMs);
    SubscriptionConfig.addQueueSize(builder, queueSize);
    SubscriptionConfig.addPublishingEnabled(builder, publishingEnabled);
    return SubscriptionConfig.endSubscriptionConfig(builder);
  }

  unpack(): SubscriptionConfigT {
    return new SubscriptionConfigT(
      this.publishingIntervalMs(),
      this.lifetimeCount(),
      this.maxKeepAliveCount(),
      this.maxNotificationsPerPublish(),
      this.priority(),
      this.samplingIntervalMs(),
      this.queueSize(),
      this.publishingEnabled(),
    );
  }

  unpackTo(_o: SubscriptionConfigT): void {
    _o.publishingIntervalMs = this.publishingIntervalMs();
    _o.lifetimeCount = this.lifetimeCount();
    _o.maxKeepAliveCount = this.maxKeepAliveCount();
    _o.maxNotificationsPerPublish = this.maxNotificationsPerPublish();
    _o.priority = this.priority();
    _o.samplingIntervalMs = this.samplingIntervalMs();
    _o.queueSize = this.queueSize();
    _o.publishingEnabled = this.publishingEnabled();
  }

  unpackFields(...fields: string[]): SubscriptionConfigT {
    const t = new SubscriptionConfigT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("publishing_interval_ms")) {
      t.publishingIntervalMs = this.publishingIntervalMs();
    }
    if (fieldSet.has("lifetime_count")) {
      t.lifetimeCount = this.lifetimeCount();
    }
    if (fieldSet.has("max_keep_alive_count")) {
      t.maxKeepAliveCount = this.maxKeepAliveCount();
    }
    if (fieldSet.has("max_notifications_per_publish")) {
      t.maxNotificationsPerPublish = this.maxNotificationsPerPublish();
    }
    if (fieldSet.has("priority")) {
      t.priority = this.priority();
    }
    if (fieldSet.has("sampling_interval_ms")) {
      t.samplingIntervalMs = this.samplingIntervalMs();
    }
    if (fieldSet.has("queue_size")) {
      t.queueSize = this.queueSize();
    }
    if (fieldSet.has("publishing_enabled")) {
      t.publishingEnabled = this.publishingEnabled();
    }
    return t;
  }
}

export class SubscriptionConfigT implements flatbuffers.IGeneratedObject {
  constructor(
    public publishingIntervalMs: number = 1000.0,
    public lifetimeCount: number = 10,
    public maxKeepAliveCount: number = 30,
    public maxNotificationsPerPublish: number = 0,
    public priority: number = 0,
    public samplingIntervalMs: number = 0.0,
    public queueSize: number = 1,
    public publishingEnabled: boolean = true,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return SubscriptionConfig.createSubscriptionConfig(
      builder,
      this.publishingIntervalMs,
      this.lifetimeCount,
      this.maxKeepAliveCount,
      this.maxNotificationsPerPublish,
      this.priority,
      this.samplingIntervalMs,
      this.queueSize,
      this.publishingEnabled,
    );
  }

  clone(): SubscriptionConfigT {
    const obj = new SubscriptionConfigT();
    obj.publishingIntervalMs = this.publishingIntervalMs;
    obj.lifetimeCount = this.lifetimeCount;
    obj.maxKeepAliveCount = this.maxKeepAliveCount;
    obj.maxNotificationsPerPublish = this.maxNotificationsPerPublish;
    obj.priority = this.priority;
    obj.samplingIntervalMs = this.samplingIntervalMs;
    obj.queueSize = this.queueSize;
    obj.publishingEnabled = this.publishingEnabled;
    return obj;
  }

  equals(other: SubscriptionConfigT): boolean {
    if (!Object.is(this.publishingIntervalMs, other.publishingIntervalMs)) return false;
    if (this.lifetimeCount !== other.lifetimeCount) return false;
    if (this.maxKeepAliveCount !== other.maxKeepAliveCount) return false;
    if (this.maxNotificationsPerPublish !== other.maxNotificationsPerPublish) return false;
    if (this.priority !== other.priority) return false;
    if (!Object.is(this.samplingIntervalMs, other.samplingIntervalMs)) return false;
    if (this.queueSize !== other.queueSize) return false;
    if (this.publishingEnabled !== other.publishingEnabled) return false;
    return true;
  }
}

export function verifySubscriptionConfig(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 8);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 1);
  } finally {
    verifier.popDepth();
  }
}
